<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h4 class="text-primary text-center text-uppercase">
          <i class="fa-solid fa-building-circle-exclamation"></i>
          Details Organization
        </h4>
      </b-col>
      <!--id-->
      <b-col cols="4" xl="3">
        <label>id</label>
        <b-form-input v-model="organization.id" :readonly="true"/>
      </b-col>
      <!-- name -->
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.name') }}</label>
        <b-form-input v-model="organization.name" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT) || !newOrganization"/>
      </b-col>
      <!-- platformId -->
      <b-col cols="4" xl="3">
        <label>platformId</label>
        <b-form-input v-model="organization.platformId" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT) || !newOrganization"/>
      </b-col>
      <!-- contactName -->
      <b-col cols="4" xl="3">
        <label>Contact Name</label>
        <b-form-input v-model="organization.contactName"
                      :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)  || !newOrganization"
        />
      </b-col>
      <!-- phone-->
      <b-col cols="4" xl="3">
        <label>Phone</label>
        <b-input-group>
          <b-form-input v-model="organization.phone" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)  || !newOrganization"/>
          <b-input-group-append>
            <a
                class="btn btn-outline-primary" target="_blank"
                v-b-tooltip :title="$t('operations.call')"
            >
              <i class="fa-solid fa-phone-volume text-primary"></i>
            </a>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <!-- email -->
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.email') }}</label>
        <b-input-group>
          <b-form-input v-model="organization.email" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT) || !newOrganization"/>
          <b-input-group-append>
            <a
                class="btn btn-outline-primary" target="_blank"
                v-b-tooltip :title="$t('operations.sendMail')"
            >
              <i class="fa-solid fa-envelope"></i>
            </a>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <!-- acronym -->
      <b-col cols="4" xl="3">
        <label>acronym</label>
        <b-input-group>
          <b-form-input v-model="organization.acronym" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT) || !newOrganization"/>
        </b-input-group>
      </b-col>

      <!--crm-->
      <b-col cols="4" xl="3">
        <label>crm</label>
        <b-form-input v-model="organization.crm" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <!--country-->
      <b-col cols="4" xl="3">
        <label>country</label>
        <countries-select-box  v-model="organization.country" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <!--lang-->
      <b-col cols="4" xl="3">
        <label>lang</label>
        <b-form-input v-model="organization.lang" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <!--currency-->
      <b-col cols="4" xl="3">
        <label>currency</label>
        <currencies-select-box  v-model="organization.currency" :allowed-currencies="['EUR','USD']" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <!--Telegram Group-->
      <b-col cols="4" xl="3">
        <label>Telegram Group</label>
        <b-form-input v-model="organization.telegramTransactionsGroup" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <!--website-->
      <b-col cols="6" xl="3">
        <label>website</label>
        <b-form-input v-model="organization.website" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <!--accountPath-->
      <b-col cols="6">
        <label>accountPath</label>
        <b-form-input v-model="organization.accountPath" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <!--websiteHealthCheckUrl-->
      <b-col cols="6">
        <label>Health Check URL</label>
        <b-form-input v-model="organization.websiteHealthCheckUrl" placeholder="https://example.com/health" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <!--currency-->
      <b-col cols="4" xl="3">
        <label>Trade Currency</label>
        <currencies-select-box  v-model="organization.defaultTradeCurrency" :allowed-currencies="['EUR','USD', 'AUD']" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
<!--      &lt;!&ndash;vat&ndash;&gt;
      <b-col cols="4" xl="3">
        <label>vat</label>
        <b-form-input v-model="organization.vat" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      &lt;!&ndash;hebCalendar&ndash;&gt;
      <b-col cols="4" xl="3">
        <label>heb Calendar</label>
        <b-form-input v-model="organization.hebCalendar" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      &lt;!&ndash;price&ndash;&gt;
      <b-col cols="4" xl="3">
        <label>price</label>
        <b-form-input v-model="organization.price" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      &lt;!&ndash;priceType&ndash;&gt;
      <b-col cols="4" xl="3">
        <label>priceType</label>
        <b-form-input v-model="organization.priceType" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>-->
    </b-row>

    <!-- buttons to save or exit -->
    <div class="text-center mt-2" style="position: absolute;bottom: 10px; width: 100%; padding: 0 10px; right: 0" >
      <b-button v-if="newOrganization" block size="md" variant="primary" @click="create" :disabled="buzy">{{$t('operations.save')}}</b-button>
      <b-button v-else block size="md" variant="warning" @click="update" :disabled="buzy">{{$t('operations.save')}}</b-button>


    </div>
  </div>
</template>

<script>
import mixinPermissions from '@/components/mixin/mixinPermissions';
import mixinNotifications from '@/components/mixin/mixinNotifications';
import Organization from '@/model/organization/Organization';
import { mapActions } from 'vuex';
import CountriesSelectBox from '@/components/widget/select/CountriesSelectBox.vue'
import CurrenciesSelectBox from '@/components/widget/select/CurrenciesSelectBox.vue'

export default {
  name: 'OrganizationEditDetails',
  components: { CurrenciesSelectBox, CountriesSelectBox },
  mixins: [mixinPermissions, mixinNotifications],
  data: () => ({
    organization: Organization(),
    buzy: false,
  }),
  props: {
    value: {
      required: true,
      default: () => ({})
    },
    newOrganization: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    value: {
      handler() {
        this.organization = Object.assign(Organization(), this.value)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('organizations', ['createOrganization','updateOrganization']),

    async create(){
      let $this = this;
      try{
        this.buzy = true
        await this.createOrganization($this.organization)
        //Reload window
        window.location.reload()
      }catch (e){
        $this.showErrorNotification($this.$t('globalMessages.fetchDataError',
            { system: "error in update organization" }), e.response.data.error)
        this.buzy = false
      }
    },

    async update(){
      let $this = this;
      try{
        let req= {id: $this.organization.id, organization: $this.organization}
        await this.updateOrganization(req)
      }catch (e){
        $this.showErrorNotification($this.$t('globalMessages.fetchDataError',
            { system: "error in update organization" }), e.response.data.error)
      }

    },

  }

};
</script>

<style scoped>

</style>
